<template>
  <div class="panel-container">
    <StudioContent
      ref="studioContentRef"
      :chat-action="chatAction"
      @studio-panel-changed="$emit('studio-panel-changed', $event)"
      @context-signal="$emit('context-signal', $event)"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import StudioContent from './StudioContent.vue'

defineProps({
  chatAction: { type: Object, default: null },
})
defineEmits(['studio-panel-changed', 'context-signal'])

const studioContentRef = ref(null)

// A switch asked for before the content child has mounted (the claim → "My
// Mystic" landing does exactly that) used to be a silent no-op, and the seeker
// landed on the Dashboard. Hold it and apply it the moment the child exists.
let pendingKey = null
function switchTab(key) {
  if (studioContentRef.value) studioContentRef.value.switchTab(key)
  else pendingKey = key
}
watch(studioContentRef, (el) => {
  if (el && pendingKey) { el.switchTab(pendingKey); pendingKey = null }
})

defineExpose({ switchTab })
</script>

<style scoped>
/* Arriving from the birth: the Studio settles in rather than snapping on. */
.panel-container { animation: studio-arrive 0.9s ease-out both; }
@keyframes studio-arrive { from { opacity: 0; transform: translateY(10px); filter: blur(6px); } to { opacity: 1; transform: none; filter: none; } }
@media (prefers-reduced-motion: reduce) { .panel-container { animation: none; } }
.panel-container {
  width: 100%;
  min-height: 100%;
  background: #0d0520;
  box-sizing: border-box;
}
</style>
